import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styles: ['./tooltip.component.scss']
})
export class TooltipComponent {
    @Input() messages: string[] = [];
}
